import { defineStore } from 'pinia'

const state = () => ({
  jobs: [],
  job: {},
})

const actions = {
  setJobs (jobs) {
    this.jobs = jobs
  },
  setJob (id, job) {
    this.job[id] = job
  }
}

export const useJobsStore = defineStore('jobs', {
  state: () => state(),
  actions
})

export default useJobsStore
